import { render, staticRenderFns } from "./pwd_recover_true.vue?vue&type=template&id=48992736"
import script from "./pwd_recover_true.vue?vue&type=script&lang=js"
export * from "./pwd_recover_true.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports